import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { RecoveryBinState } from '@reducers/recovery-bin';

// Deleted Patients List
export const getDeletedPatients = (state: RootState): RecoveryBinState => state.recoveryBin;
export const getDeletedPatientsData = createSelector(getDeletedPatients, (patients) => patients?.data);
export const getDeletedPatientsItems = createSelector(getDeletedPatients, (patients) => patients?.data?.items);
export const getDeletedPatientsTotal = createSelector(getDeletedPatients, (patients) => patients?.data?.total);
export const getDeletedPatientsError = createSelector(getDeletedPatients, (patients) => patients?.error as Error);
export const getDeletedPatientsFilter = createSelector(getDeletedPatients, (patients) => patients?.filter);
export const isDeletedPatientsLoading = createSelector(getDeletedPatients, (patients) => patients?.loading);
